type Speaker = {
  type: string
  name: string
  designation: string
  avatar?: string
}

export type Event = {
  type: string
  title: string
  time: string
  speakers: Speaker[]
}

export type ElevateStage = {
  no: number
  title: string
  topic: string
  gradient: string
  events: Event[]
}

export const speakers = [
  {
    name: 'Amit Pande',
    designation: 'CMO & EVP Strategy',
    company: 'Aviso AI',
    avatar: '/assets/elevate-generative-ai/speakers/Amit_Pande.png'
  },
  {
    name: 'Ansh Mehra',
    designation: 'Product Marketer',
    company: 'Zuddl',
    avatar: '/assets/elevate-generative-ai/speakers/Ansh_Mehra.png'
  },
  {
    name: 'Anthony Kennada',
    designation: 'Co-Founder & CEO',
    company: 'Audience plus',
    avatar: '/assets/elevate-generative-ai/speakers/Anthony_Kennada.png'
  },
  {
    name: 'Ashray Malhotra',
    designation: 'Co-founder and CEO',
    company: 'Rephrase.ai',
    avatar: '/assets/elevate-generative-ai/speakers/Ashray_Malhotra.png'
  },
  {
    name: 'Anum Hussain',
    designation: 'Head of Content Marketing',
    company: 'Reforge',
    avatar: '/assets/elevate-generative-ai/speakers/Anum_Hussain.png'
  },

  {
    name: 'Brett McGrath',
    designation: 'VP of Marketing',
    company: 'The Juice',
    avatar: '/assets/elevate-generative-ai/speakers/Brett.png'
  },
  {
    name: 'Brianna Valleskey',
    designation: 'Head of Content',
    company: 'Inscribe',
    avatar: '/assets/elevate-generative-ai/speakers/Brianna_Valleskey.png'
  },
  {
    name: 'Chitra Rakesh',
    designation: 'Head of Content',
    company: 'Sigma Computing',
    avatar: '/assets/elevate-generative-ai/speakers/Chitra_Rakesh.png'
  },
  {
    name: 'Greg Perotto',
    designation: 'Chief Marketing Officer',
    company: 'Secureframe',
    avatar: '/assets/elevate-generative-ai/speakers/Greg_Perotto.png'
  },
  {
    name: 'Gregory Kennedy',
    designation: 'Founder and Principal Consultant',
    company: 'BrandZen',
    avatar: '/assets/elevate-generative-ai/speakers/Gregory_Kennedy.png'
  },
  {
    name: 'Jake Link',
    designation: 'Head of Content Marketing',
    company: 'BRYTER',
    avatar: '/assets/elevate-generative-ai/speakers/Jake_Link.png'
  },
  {
    name: 'Michael Shuffett',
    designation: 'Founder & CEO	',
    company: 'Compose AI',
    avatar: '/assets/elevate-generative-ai/speakers/Michael_Shuffett.png'
  },
  {
    name: 'Michaela Rollings',
    designation: 'Head of Brand and Content',
    company: 'Hive',
    avatar: '/assets/elevate-generative-ai/speakers/Michaela.png'
  },
  {
    name: 'Michelle Gaines',
    designation: 'Chief Marketing and Content Officer',
    company: 'Preqin',
    avatar: '/assets/elevate-generative-ai/speakers/Michelle_Gaines.png'
  },
  {
    name: 'Monica Norton',
    designation: 'Head of Content Marketing',
    company: 'Yelp',
    avatar: '/assets/elevate-generative-ai/speakers/Monica_Norton.png'
  },
  {
    name: 'Parth Mukherjee',
    designation: 'Vice President Product Marketing',
    company: 'Mindtickle',
    avatar: '/assets/elevate-generative-ai/speakers/Parth_Mukherjee.png'
  },
  {
    name: 'Rafa Jimenez',
    designation: 'Founder & CEO',
    company: 'Seenapse',
    avatar: '/assets/elevate-generative-ai/speakers/Rafa.png'
  },
  {
    name: 'Sarah Beldo',
    designation: 'Head of Content Marketing',
    company: 'Sanity',
    avatar: '/assets/elevate-generative-ai/speakers/Sarah_Beldo.png'
  },
  {
    name: 'Shawn Gaines',
    designation: 'Chief Marketing Officer',
    company: 'Sertifi',
    avatar: '/assets/elevate-generative-ai/speakers/Shawn_Gaines.png'
  },

  {
    name: 'Steve Hoechster',
    designation: 'Director of Content & Communications',
    company: 'Stensul',
    avatar: '/assets/elevate-generative-ai/speakers/Steve_Hoechster.png'
  },
  {
    name: 'Steve Mudd',
    designation: 'Director of Content & Communications',
    company: 'NetApp',
    avatar: '/assets/elevate-generative-ai/speakers/Steve_Mudd.png'
  },
  {
    name: 'Sujith Ravi',
    designation: 'Founder & CEO',
    company: 'SliceX AI',
    avatar: '/assets/elevate-generative-ai/speakers/Sujith.png'
  },

  {
    name: "Susi O'Neill ",
    designation: 'Head of Brand Content',
    company: 'Kaspersky',
    avatar: '/assets/elevate-generative-ai/speakers/Susi.png'
  }
]

export const Stage1Events = [
  {
    type: 'Fireside Chat',
    title: 'The Future of Customer Experience with Emerging Technologies',
    time: '10:00 - 10:30 PT',
    speakers: [
      {
        type: 'Speaker',
        name: `Susi O'Neill`,
        designation: 'Head of Brand Content | Kaspersky',
        avatar: '/assets/elevate-generative-ai/speakers/Susi.png'
      }
    ]
  },
  {
    type: 'Panel Discussion',
    title:
      'Developing a Thought Leadership Strategy as an Industry Expert Through Content',
    time: '10:30 - 11:00 PT',
    speakers: [
      {
        type: 'Speaker',
        name: 'Gregor Perotto',
        designation: 'Chief Marketing Officer | Secureframe',
        avatar: '/assets/elevate-generative-ai/speakers/Greg_Perotto.png'
      },
      {
        type: 'Speaker',
        name: 'Monica Norton',
        designation: 'Head of Content Marketing | Yelp',
        avatar: '/assets/elevate-generative-ai/speakers/Monica_Norton.png'
      },
      {
        type: 'Speaker',
        name: 'Chitra Rakesh',
        designation: 'Head of Content | Sigma Computing',
        avatar: '/assets/elevate-generative-ai/speakers/Chitra_Rakesh.png'
      }
    ]
  },
  {
    type: 'Panel Discussion',
    title:
      'Metrics that Matter: Measure the Success of Content Marketing Campaigns',
    time: '11:00 - 11:30 PT',
    speakers: [
      {
        type: 'Speaker',
        name: 'Brianna Valleskey',
        designation: 'Head of Content Marketing | Inscribe',
        avatar: '/assets/elevate-generative-ai/speakers/Brianna_Valleskey.png'
      },
      {
        type: 'Speaker',
        name: 'Sarah Beldo',
        designation: 'Content Marketing | Sanity',
        avatar: '/assets/elevate-generative-ai/speakers/Sarah_Beldo.png'
      }
    ]
  },
  {
    type: 'Panel Discussion',
    title: 'Building a Content Strategy That Achieves Business Objectives',
    time: '12:00 - 12:30 PT',
    speakers: [
      {
        type: 'Speaker',
        name: 'Jake Link',
        designation: 'Head of Content Marketing | BRYTER',
        avatar: '/assets/elevate-generative-ai/speakers/Jake_Link.png'
      },
      {
        type: 'Speaker',
        name: 'Michelle Gaines',
        designation: 'Chief Marketing and Content Officer | Preqin',
        avatar: '/assets/elevate-generative-ai/speakers/Michelle_Gaines.png'
      },
      {
        type: 'Speaker',
        name: 'Steve Mudd',
        designation: 'Director of Strategic Messaging and Content | NetApp',
        avatar: '/assets/elevate-generative-ai/speakers/Steve_Mudd.png'
      }
    ]
  },
  {
    type: 'Panel Discussion',
    title: 'Collaborative Intelligence: When Humans and AI Team Up',
    time: '13:00 - 13:30 PT',
    speakers: [
      {
        type: 'Speaker',
        name: 'Gregory Kennedy',
        designation: 'Founder and Principal Consultant | BrandZen',
        avatar: '/assets/elevate-generative-ai/speakers/Gregory_Kennedy.png'
      },
      {
        type: 'Speaker',
        name: 'Parth Mukherjee',
        designation: 'Vice President Product Marketing | Mindtickle',
        avatar: '/assets/elevate-generative-ai/speakers/Parth_Mukherjee.png'
      },
      {
        type: 'Speaker',
        name: 'Michael Shuffett',
        designation: 'Founder & CEO | Compose AI',
        avatar: '/assets/elevate-generative-ai/speakers/Michael_Shuffett.png'
      }
    ]
  }
]

export const Stage2Events = [
  {
    type: 'Panel Discussion',
    title: 'Incorporating Generative AI into Marketing: Where to Start',
    time: '10:00 - 10:30 PT',
    speakers: [
      {
        type: 'Speaker',
        name: 'Shawn Gaines',
        designation: 'Chief Marketing Officer | Sertifi',
        avatar: '/assets/elevate-generative-ai/speakers/Shawn_Gaines.png'
      },
      {
        type: 'Speaker',
        name: 'Anum Hussain',
        designation: 'Head of Content Marketing | Reforge',
        avatar: '/assets/elevate-generative-ai/speakers/Anum_Hussain.png'
      }
    ]
  },
  {
    type: 'Panel Discussion',
    title: 'Maximizing Content Marketing ROI with Generative AI',
    time: '10:30 - 11:00 PT',
    speakers: [
      {
        type: 'Speaker',
        name: 'Michaela Rollings',
        designation: 'Head of Brand and Content | Hive',
        avatar: '/assets/elevate-generative-ai/speakers/Michaela.png'
      },
      {
        type: 'Speaker',
        name: 'Brett McGrath',
        designation: 'VP of Marketing | The Juice',
        avatar: '/assets/elevate-generative-ai/speakers/Brett.png'
      }
    ]
  },
  {
    type: 'Masterclass',
    title: 'Better prompts, better results - Learn how to talk to AI',
    time: '11:30 - 12:00 PT',
    speakers: [
      {
        type: 'Speaker',
        name: 'Ansh Mehra',
        designation: 'Product Marketing Manager | Zuddl',
        avatar: '/assets/elevate-generative-ai/speakers/Ansh_Mehra.png'
      }
    ]
  },
  {
    type: 'Panel Discussion',
    title: 'The Future of Content with Generative AI',
    time: '12:00 - 12:30 PT',
    speakers: [
      {
        type: 'Speaker',
        name: 'Rafa Jimenez',
        designation: 'Founder & CEO | Seenapse',
        avatar: '/assets/elevate-generative-ai/speakers/Rafa.png'
      },
      {
        type: 'Speaker',
        name: 'Anthony Kennada',
        designation: 'Co-Founder & CEO | Audience plus',
        avatar: '/assets/elevate-generative-ai/speakers/Anthony_Kennada.png'
      }
    ]
  },
  {
    type: 'Panel Discussion',
    title: 'The Power of Generative AI in Marketing Automation',
    time: '12:30 - 13:00 PT',
    speakers: [
      {
        type: 'Speaker',
        name: 'Ashray Malhotra',
        designation: 'Founder | Rephrase',
        avatar: '/assets/elevate-generative-ai/speakers/Ashray_Malhotra.png'
      },
      {
        type: 'Speaker',
        name: 'Sujith Ravi',
        designation: 'Founder & CEO | SliceX AI',
        avatar: '/assets/elevate-generative-ai/speakers/Sujith.png'
      }
    ]
  },
  {
    type: 'Fireside Chat',
    title: 'Elevate Your B2B Marketing Game with the Magical Touch of Gen AI',
    time: '13:00 - 13:30 PT',
    speakers: [
      {
        type: 'Speaker',
        name: 'Amit Pande',
        designation: 'EVP Growth, Chief Marketing Officer | Aviso AI',
        avatar: '/assets/elevate-generative-ai/speakers/Amit_Pande.png'
      }
    ]
  }
]

export const stages: Record<number, ElevateStage> = {
  1: {
    no: 1,
    title: 'Stage 1',
    topic: 'Maximizing Content Marketing',
    gradient: 'linear-gradient(80deg, #8C4AE8 3%, #1600E5 90%)',
    events: Stage1Events
  },
  2: {
    no: 2,
    title: 'Stage 2',
    topic: 'AI-powered innovation',
    gradient: 'linear-gradient(90deg, #28BDD5 -4%, #9C60EF 115%)',
    events: Stage2Events
  }
}
